export default __webpack_public_path__ + "static/media/spun.ab565119.png";